import React from "react";

class Mobile extends React.Component {
    render() {
        return <h1>Home page</h1>;
    }
}
export default Mobile;
